// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ArrowAltRight(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowAltRight" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M13.5 19.5L22.5 12L13.5 4.5V9.75H1.5V14.25H13.5V19.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ArrowAltRight.js.map